<template>
  <SfModal
    class="fz-modal"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </SfModal>
</template>

<script>
import { SfModal } from '@storefront-ui/vue';

export default {
  name: 'Modal',
  components: {
    SfModal,
  },
};
</script>

<style lang="scss">
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";

.fz-modal {
  .sf-modal__container {
    @include sf-desktop {
      --modal-width: 95%;
      max-width: 1024px;
      max-height: 95%;
      z-index: 10;
    }
  }
}
</style>
